import {OccMemberConfig} from '@vista/omnichannel-components-ui'
import {defaultOccMemberConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/member/member'

export function getMemberConfigData():OccMemberConfig {
    return {
        ...defaultOccMemberConfig
    }
}